/*
 * @@Copyright (c): Knowdee All rights reserved.
 * @Description: 国际化模块
 * @Author: wangwz@knowdee.com
 * @LastEditors: wangwz@knowdee.com
 * @Date: 2022-06-10 17:50:43
 * @LastEditTime: 2023-02-04 16:27:14
 * @FilePath: /client-h5-v2/src/lang/index.ts
 */
import { App } from 'vue'
import { createI18n } from 'vue-i18n'
// 引入语言包
import store from '@/store/index'
import de from '@/lang/package/de'
import en from '@/lang/package/en'
import hi from '@/lang/package/hi'
import es from '@/lang/package/es'
import fr from '@/lang/package/fr'
import it from '@/lang/package/it'
import ja from '@/lang/package/ja'
import pl from '@/lang/package/pl'
import pt from '@/lang/package/pt'
import zhCn from '@/lang/package/zh-cn'
// 定义语言表
const message:any = {
  de: de,
  en: en,
  hi: hi,
  es: es,
  fr: fr,
  it: it,
  ja: ja,
  pl: pl,
  pt: pt,
  zh: zhCn
}

// 初始化i18n
const i18n:any = createI18n({
  // legacy: false,
  locale: store.getters['global/language'] || 'en', // 默认显示的语言
  messages: message
})
export const lang = (app: App<Element>) => {
  // 语言切换简码
  const locale = store.getters['global/language'] || 'en'
  // 首次进入默认语言设置
  i18n.global.locale = locale
  // 将对应语言对象存储到全局，便于app组件切换element-plus多语言
  store.commit('global/SET_I18N_ELEMENT', message[locale])
  // 注册i18n到组件
  app.use(i18n)
  app.config.globalProperties.$i18n = i18n
}
